import { LicenseTicketDto } from '../../../api/models/users';
import { isPending } from '../../../common/pending-changes';

export const hasPendingChanges = (tickets: LicenseTicketDto[]) => tickets.filter((el) => isPending(el.id || '')).length > 0;
